/* eslint-disable @typescript-eslint/no-explicit-any */
import { Loading3QuartersOutlined } from "@ant-design/icons";
import { Spin } from "antd";
import { useState } from "react";
import TypeForm from "./TypeForm";
// import DrawForm from "./DrawForm";
// import UploadForm from "./UploadForm";

const antIcon = <Loading3QuartersOutlined spin />;

interface PropsType {
  onClose: () => void;
  proposalDocumentData?: {
    email: string;
    first_name: string;
    id: string;
    last_name: string;
    phone: string;
    title: string;
  };
}

const SignModal = (props: PropsType) => {
  const { onClose, proposalDocumentData } = props;
  const [loading, setLoading] = useState(false);

  const onCloseHandler = () => {
    onClose();
  };

  // const tabsItems: TabsProps["items"] = [
  //   {
  //     key: "type",
  //     label: "Type",
  //     children: (
  //       <TypeForm
  //         setLoading={setLoading}
  //         onClose={onCloseHandler}
  //         proposalDocumentData={proposalDocumentData}
  //       />
  //     ),
  //   },
  //   // {
  //   //   key: "draw",
  //   //   label: "Draw",
  //   //   children: (
  //   //     <DrawForm
  //   //       setLoading={setLoading}
  //   //       onClose={onCloseHandler}
  //   //       proposalDocumentData={proposalDocumentData}
  //   //     />
  //   //   ),
  //   // },
  //   // {
  //   //   key: "upload",
  //   //   label: "Upload",
  //   //   children: <UploadForm setLoading={setLoading} onClose={onCloseHandler} />,
  //   // },
  // ];

  return (
    <Spin indicator={antIcon} size="large" spinning={loading}>
      <div className="signFormModal">
        <div className="signFormHeader">
          <h2 style={{ marginBottom: "12px" }}>Sign & accept</h2>
          <p style={{ marginBottom: "20px" }}>
            Choose a signature method to confirm your identity and complete the
            signing process.
          </p>
        </div>

        <div className="modal_content">
          {/* <Tabs
            defaultActiveKey="1"
            items={tabsItems}
            className="propertiesTabs"
          /> */}
          <TypeForm
            setLoading={setLoading}
            onClose={onCloseHandler}
            proposalDocumentData={proposalDocumentData}
          />
        </div>
      </div>
    </Spin>
  );
};

export default SignModal;
